export const AUTH_STORAGE_KEYS = {
  token: "token",
  adminInfo: "admin_info",
  menuTree: "menu_tree",
  permissionKeys: "permission_keys",
  defaultPath: "default_path",
  navList: "nav_list",
};

export const AUTH_ROUTE_FALLBACK = "/index/data";
